import { DestinationEvent } from '@eventbrite/event-renderer';
import React from 'react';
import {
    Breadcrumb,
    ThingsToDoBreadcrumbs,
} from '../../containers/ThingsToDoBreadcrumbs';
import { NearbyPOIShape } from '../../types/AppProps';
import { AboutPOI } from './containers/AboutPOI';
import { EventSection } from './containers/EventSection';
import { NearbyPOI } from './containers/NearbyPOI';
import {
    POIHeroSection,
    POIHeroSectionProps,
} from './containers/POIHeroSection';
import { PointsOfInterestFAQs } from './containers/PointsOfInterestFAQs';
import styles from './PointOfInterestPage.module.scss';

export interface PointOfInterest {
    pointOfInterestName: string;
    geometry: {
        latitude: number;
        longitude: number;
    };
    types: string[];
    photos: Object[];
    placeId: string;
    description: string;
    address: {
        formattedAddress: string;
        city: string;
        state: string;
        country: string;
    };
    htmlAttribution: string;
    slugs: {
        country: string;
        city: string;
    };
    imageSource: string;
    geography: {
        latitude: string;
        longitude: string;
    };
    hoursOfOperation: Array<string>;
    popularEvents: Array<{
        eventName: string;
        eventSlug: string;
    }>;
}

export interface PointOfInterestProps {
    pointOfInterest: PointOfInterest;
    heroSection: POIHeroSectionProps;
    breadcrumbs: Breadcrumb[];
    nearbyPointsOfInterest: Array<NearbyPOIShape>;
    nearbyEvents: Array<DestinationEvent>;
}

export const PointOfInterestPage: React.FunctionComponent<
    PointOfInterestProps
> = (props) => {
    const {
        pointOfInterest,
        nearbyPointsOfInterest,
        breadcrumbs,
        nearbyEvents,
    } = props;

    return (
        <>
            <div className={styles.topSection}>
                <ThingsToDoBreadcrumbs
                    containerClasses={styles.breadcrumbs}
                    breadcrumbs={breadcrumbs}
                />
                <POIHeroSection
                    pointOfInterestName={pointOfInterest.pointOfInterestName}
                    imageSource={pointOfInterest.imageSource}
                    htmlAttribution={pointOfInterest.htmlAttribution}
                />
            </div>
            <AboutPOI
                pointOfInterestName={pointOfInterest.pointOfInterestName}
                description={pointOfInterest.description}
                address={pointOfInterest.address?.formattedAddress}
            />
            <EventSection
                pointOfInterestName={pointOfInterest.pointOfInterestName}
                nearbyEvents={nearbyEvents} // placeholder data
            />
            <div className={styles.bottomSection}>
                <NearbyPOI
                    pointOfInterestName={pointOfInterest.pointOfInterestName}
                    nearbyPointsOfInterest={nearbyPointsOfInterest}
                />
                <PointsOfInterestFAQs
                    pointOfInterestName={pointOfInterest.pointOfInterestName}
                    hoursOfOperation={pointOfInterest.hoursOfOperation}
                    nearbyPointsOfInterest={nearbyPointsOfInterest}
                    nearbyEvents={nearbyEvents}
                />
            </div>
        </>
    );
};
